import type { NextPage } from 'next'
import { Footer } from '../components/Footer/Footer'
import { VrtBrandLogoBar } from '../components/VrtBrandLogoBar/VrtBrandLogoBar'
import { LandingPageHeader } from '../components/Header/LandingPageHeader'
import SEO from '../components/SEO'
const ContactPage: NextPage = () => {
	return (
		<>
			<SEO
				title={'Contacteer Open Media'}
				description={
					'Heb je een vraag voor Open Media? Contacteer ons via onderstaande gegevens.'
				}
			/>
			<LandingPageHeader />
			<div className={'-mt-10'}>
				<aside className="overflow-hidden bg-[url(/heroImage.jpeg)] bg-center bg-no-repeat bg-cover">
					<div className="p-8 md:p-12 lg:px-16 md:py-24 lg:py-36 bg-black/20">
						<div className="text-center">
							<h1
								className="font-bold text-9xl 2xl:text-[200px] text-transparent"
								style={{
									WebkitTextStroke: '2px',
									WebkitTextStrokeColor: 'white',
								}}
							>
								Contact
							</h1>
						</div>
					</div>
				</aside>
			</div>
			<section className="container max-w-7xl mx-auto px-6">
				<div className="py-8 lg:py-16 mx-auto text-center text-max-dark-blue">
					<div className="pb-4">
						<h2 className="text-4xl font-semibold md:text-5xl lg:text-6xl ">
							Contacteer Open Media
						</h2>
						<p className="text-2xl font-light lg:text-2xl sm:px-16 xl:px-48 text-max-dark-blue py-10">
							Heb je een vraag of opmerking voor Open Media?
							Contacteer ons via openmedia@vrt.be
						</p>
					</div>
				</div>
			</section>

			<Footer />
		</>
	)
}

export default ContactPage
